import React, { useState } from 'react'
import { useWindowDimensions, ScrollView, View } from 'react-native'
import { Text } from '@ui-kitten/components'
import tailwind from 'tailwind-rn'
import Accordion from 'react-native-collapsible/Accordion'
import { useMediaQuery } from 'react-responsive'

import Colors from '../constants/Colors'

import { SafeAreaView } from 'react-native-safe-area-context'
import HeaderInterno from '../components/HeaderInterno'
import FooterInterno from '../components/FooterInterno'
import FooterMenu from '../components/FooterMenu'

const SECTIONS = [
  {
    title: 'O QUE É GROWTH?',
    content: 'Growth é uma metodologia orientada ao crescimento dos negócios, focada na mudança de mentalidade empresarial, que contribui para a qualificação das equipes das empresas. A metodologia utiliza instrumentos criados pelo marketing digital, acessíveis a todo tamanho de negócio, e combina com ferramentas fáceis de utilizar e de baixo custo.',
  },
  {
    title: 'COMO O GROWTH PODE ME AJUDAR?',
    content: 'Growth vai além de uma única área como Marketing ou Vendas. Ele é uma visão macro e busca oportunidades e alavancas de crescimento em todas as esferas e estruturas do negócio. Sempre apontando para o crescimento como resultado do “olhar para geração de valor” em todas as etapas da Jornada de Experiência do Consumidor.',
  },
  {
    title: 'QUEM REALIZA OS PROGRAMAS?',
    content: 'Os Programas são criados pelo Senac em parceria com consultores especializados. Estes mesmos consultores estão envolvidos diretamente na capacitação.',
  },
  {
    title: 'O PROGRAMA GROWTH SERVE PARA PESSOA FÍSICA?',
    content: 'O Programa Growth é voltado ao crescimento e amadurecimento empresarial e é necessário CNPJ para realizar a inscrição.',
  },
  {
    title: 'COMO FAÇO MINHA INSCRIÇÃO?',
    content: 'A inscrição pode ser feita através do site clicando no botão de inscrição ou através do Whatsapp (71) 3186-4000 (podemos colocar o link aqui para direcionar ao google forms)',
  },
  {
    title: 'NÃO TENHO CNPJ. POSSO PARTICIPAR DO PROGRAMA GROWTH?',
    content: 'Para o Programa Growth é necessário CNPJ.',
  },
  {
    title: 'NÃO TENHO CNPJ. POSSO PARTICIPAR DO PROGRAMA DE CAPACITAÇÃO?',
    content: 'Para o Programa Capacitação Sob Medida não é necessário CNPJ, dessa forma está aberto a Pessoa Física.',
  },
  {
    title: 'QUANDO ABRE A PRÓXIMA TURMA DE GROWTH?',
    content: 'O Programa está dividido em 3 ciclos de aprendizado, mas isso não impede sua entrada a qualquer momento dos ciclos já que o desenvolvimento dos conteúdos e práticas se dá de maneira pessoal. ',
  },
  {
    title: 'QUAL A RELAÇÃO DO SENAC E DO SEBRAE COM A ACADEMIA DE SOLUÇÕES EMPREENDEDORAS?',
    content: 'A Academia de Soluções Empreendedoras é uma iniciativa conjunta destas duas instituições.',
  },
  {
    title: 'QUANTO CUSTA O PROGRAMA GROWTH?',
    content: 'O Programa Growth é gratuito, porém tem número de vagas limitadas.',
  },
];


export default function PerguntasFrequentes() {

  const [activeSections, setActiveSections] = useState([0])
  const isLargeScreen = useMediaQuery({minDeviceWidth: 440})
  const windowWidth = isLargeScreen ? 800 : useWindowDimensions().width
  const windowHeight = useWindowDimensions().height

  const _renderHeader = (section) => {
    return (
      <View style={tailwind('mt-5 mb-1')}>
        <Text style={{fontWeight: 'bold', color: Colors.roxo}}>{section.title}</Text>
      </View>
    )
  }

  const _renderContent = (section) => {
    return (
      <View >
        <Text>{section.content}</Text>
      </View>
    )
  }

  const _updateSections = (activeSections) => {
    setActiveSections(activeSections)
  }

      return (
        <SafeAreaView style={{flex:1, backgroundColor: "#ece7e7"}}>
          <HeaderInterno title="PERGUNTAS FREQUENTES" />
          <ScrollView style={{height: windowHeight, width: windowWidth}}>
            <View style={[tailwind('bg-white mx-7 mt-5 mb-40'), { shadowColor: '#000', shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85, borderRadius: 20 }]}>
              <View style={[tailwind('mx-5 self-center mb-10'), {marginTop: isLargeScreen ? 110 : 150}]}>
              <Accordion
                  activeSections={activeSections}
                  sections={SECTIONS}
                  renderHeader={_renderHeader}
                  renderContent={_renderContent}
                  onChange={_updateSections}
                  renderAsFlatList={false}
                />
              </View>
            </View>
            {!isLargeScreen && <FooterInterno />}
          </ScrollView>
          <FooterMenu />
        </SafeAreaView>
      )


}
